import React, { useState } from "react";

export default function SubscriptionImageComponent() {
  return (
    <div className="border-b">
      <div className="px-4 py-11 xl:px-0 max-w-screen-xl m-auto">
        <div className="w-full relative select-none">
          <img
            className="object-cover rounded-md"
            src={`${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/2e860b42-1f28-4423-b1c7-dd996e757a2f?auto=format`}
            alt=""
          />
        </div>
      </div>
    </div>
  );
}
